<!-- App.vue -->
<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import BackToTop from './components/BackToTop.vue';
import AppHeader from './components/AppHeader.vue';

const route = useRoute();


const isIndustryPolicyPage = computed(() => {
  return route.path === '/policy-simulation/industry-policy' ||
          route.path === '/data-warehouse/data-overview'||
          route.path === '/login'||
           route.path === '/register' ||
          route.path.startsWith('/embed/')
});


</script>

<template>
  <div id="app">
    <AppHeader v-if="route.matched.length > 0 && !isIndustryPolicyPage && !route.meta.standalone" />
    <router-view />
    <BackToTop v-if="route.matched.length > 0 && !route.meta.standalone" />
  </div>
</template>

<style>
/* 全局重置和基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 16px;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}

body {
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f5f7fa;
  overflow-x: hidden;
  width: 100%;
}

#app {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

/* 响应式图片 */
img {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
}

/* 链接样式 */
a {
  color: #5ecbec;
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: #40b8e0;
}

/* 响应式视口适配 */
@media (max-width: 768px) {
  html {
    font-size: 15px;
  }
}

@media (max-width: 576px) {
  html {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  html {
    font-size: 13px;
  }
}


/* 在全局样式文件中添加 */
.el-dropdown:focus {
  outline: none !important;
}

.el-dropdown__popper .el-dropdown-menu:focus {
  outline: none !important;
}

</style>